// 🎶 Danser — statues musicales : l'adversaire danse au bout du chemin. Tant que la musique joue,
// le joueur avance ; elle s'annonce (WARN) puis s'arrête (FREEZE) : bouger d'une case pendant
// l'arrêt renvoie le joueur au départ.
import { baseState, countTick, finish, sameCell, timeGain } from './common.js';

export const MUSIC_TICKS = [3, 5];  // durée de la musique (tics), tirée entre ces bornes
export const WARN_TICKS = 1;
export const FREEZE_TICKS = [2, 3];

const between = ([min, max], random) => min + Math.min(max - min, Math.floor(random() * (max - min + 1)));

/** Phase suivante du cycle musique → annonce → arrêt → musique… */
function nextPhase(phase, random) {
  if (phase === 'music') return { phase: 'warn', phaseLeft: WARN_TICKS };
  if (phase === 'warn') return { phase: 'freeze', phaseLeft: between(FREEZE_TICKS, random) };
  return { phase: 'music', phaseLeft: between(MUSIC_TICKS, random) };
}

export const dance = {
  id: 'dance',
  create(ctx) {
    const length = Math.max(1, ctx.path.length - 1);
    return baseState(ctx, {
      rival: ctx.path.at(-1),
      budget: Math.max(12, length * 4),
      idleTicks: 3,
      start: { ...ctx.path[0] },
      ...nextPhase('freeze', ctx.random ?? Math.random),
    });
  },
  tick(state, { random = Math.random }) {
    const next = countTick(state);
    if (next.result) return next;
    const phaseLeft = next.phaseLeft - 1;
    return phaseLeft > 0 ? { ...next, phaseLeft } : { ...next, ...nextPhase(next.phase, random) };
  },
  enter(state, { player }) {
    if (state.result) return state;
    if (state.phase === 'freeze') return { ...state, sendPlayerTo: state.start };
    return sameCell(state.rival, player) ? finish(state, 'win') : state;
  },
  gain: (state) => timeGain(state.fullGain, state.ticks, state.budget),
  isIdle: (state) => state.ticks >= state.idleTicks,
  hints: (state) => [{ key: 'scenario.dance.hint.rival', cell: state.rival }],
};
